import React from 'react';
import Image from 'next/image';
import { EmojiNode } from './utils/rich-parser';

interface Props {
  node: EmojiNode;
  richTextProps: {
    style?: React.CSSProperties;
    emojiStyle?: React.CSSProperties;
  };
}

const defaultStyle = {
  display: 'inline-block',
  verticalAlign: '-3px',
  marginLeft: '1px',
  marginRight: '1px',
};

export default function Emoji({ node, richTextProps }: Props) {
  // 在设计稿上面 emojiSize 会比 fontSize 大2px
  const { emojiStyle = {} } = richTextProps || {};
  const emojiSize = richTextProps?.style?.fontSize || 14;
  let emojiSizeNum = typeof emojiSize === 'string' ? Number(/\d+(\.\d+)?/.exec(emojiSize)[0]) : emojiSize;
  if (emojiSizeNum > 0) {
    emojiSizeNum += 2;
  }

  return (
    <span
      className='mx-0.5'
      style={{
        ...defaultStyle,
        ...emojiStyle,
      }}
    >
      <Image src={node.imageUrl} width={emojiSizeNum} height={emojiSizeNum} alt='' />
    </span>
  );
}
